import colorData from "./colors.json";

interface Color {
  hex: string;
  foregroundKey: string;
}

const colors = colorData as Record<string, Color>;

const AVATAR_COLORS = [
  "b300",
  "t400",
  "k400",
  "a500",
  "y400",
  "o400",
  "p300",
  "l300",
].map((colorKey) => {
  const color = colors[colorKey];
  return {
    bg: color.hex,
    fg: colors[color.foregroundKey].hex,
  };
});

export { AVATAR_COLORS };
